import { apiFetch } from './ApiService.js';
import type { IToastService } from './ToastService.js';

/// Håndterer write-actions for system-settings (`data-action="save-mx-host"`).
/// Læser feltet fra DOM og kalder Admin-app's `/api/settings`-broker, som er
/// in-proc-vejen til `SystemSettingsService.SetMxHostAsync`.
///
/// MX-host bor i den delte DB (system_settings), ikke i per-service config —
/// så den konfigureres ét sted selv med flere SMTP-/API-instanser.

interface BrokerResponse {
  ok: boolean;
  detail?: string | null;
}

export interface ISettingsActionsService {
  saveMxHost(): Promise<void>;
}

export class SettingsActionsService implements ISettingsActionsService {
  constructor(
    private readonly toast: IToastService,
    private readonly doc: Document = document,
  ) { }

  async saveMxHost(): Promise<void> {
    const input = this.doc.querySelector<HTMLInputElement>('#setting-mx-host');
    if (!input) {
      console.warn('save-mx-host: #setting-mx-host not found');
      return;
    }
    const mxHost = input.value.trim();
    if (!mxHost) {
      this.toast.show('Angiv et MX-hostname (fx mail.example.com)', 'error');
      return;
    }

    try {
      const resp = await apiFetch('/api/settings/mx-host', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ mxHost }),
      });
      const body = (await resp.json().catch(() => ({ ok: false }))) as BrokerResponse;
      if (resp.ok && body.ok) {
        this.toast.show('MX-host gemt', 'success');
        window.location.reload();
        return;
      }
      this.toast.show(`Kunne ikke gemme MX-host: ${body.detail ?? `HTTP ${resp.status}`}`, 'error');
    } catch (e) {
      console.error(e);
      this.toast.show('Netværksfejl — kunne ikke nå Admin-server', 'error');
    }
  }
}
